import { Injectable } from '@angular/core';
import { Question } from '@app/forms/subscription/definition/interface';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { ValidationBridgeService } from './validation-bridge.service';

import { UserAuthentified } from '@app/authentification/user-authentified.interface';

@Injectable({
  providedIn: 'root',
})
export class ResultTailoredQustionsService {
  constructor(private cBService: ValidationBridgeService) {}
  resultTailoredQustions: Question[] = [
    {
      name: 'signatureElectronic',
      template: 'signatureElectronic',
      callbackValidation: entity => {
        return this.cBService.getSignatureElectronic(entity);
      },
      callbackBasedOn(pledge: PledgeRead, user: UserAuthentified) {
        if (user) {
          if (user?.sessionConsultant) return true;
        }
        return false;
      },
      // callbackBasedOn(pledge: PledgeRead) {
      //   return pledge?.parameters?.initiatedByConsultant;
      // },
      isConsultant: false,
      title: 'Signature électronique du contrat',
      subTitle:
        'Vous trouverez le récapitulatif de votre proposition de souscription.',
      type: 'owners',
      category: 'Signature',
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',
        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'leadCompletionSubscription',
      template: 'leadCompletionSubscription',
      title: 'La souscription est-elle complète ?',
      // Pas de callbackBasedOn ici : isConsultant:true suffit (Question réservée aux sessions
      // consultant, cf. InMemoryDataService.getClientQuestions). Un callbackBasedOn "hide if
      // sessionConsultant" existait auparavant mais n'avait jamais d'effet réel : isConsultant
      // court-circuitait le calcul de visibilité côté consultant avant même qu'il soit évalué (bug
      // corrigé dans in-memory-data.service.ts/BaseSubscriptionComponent.ts) ; l'évaluer réellement
      // masquerait cette slide en permanence côté consultant, ce qui contredit son but.
      isConsultant: true,
      type: 'owners',
      category: 'Signature',
      productType: ['PRESTATION'],
    },

    {
      name: 'sendCompletionSubscriptionEmail',
      template: 'sendCompletionSubscriptionEmail',
      title: 'Le lien a bien été envoyé à votre client',
      subTitle:
        "Dès qu'il aura complété la souscription, vous serez notifié par mail.",
      type: 'products',
      category: 'Signature',
      productType: ['PRESTATION'],
      callbackBasedOn: (pledge: PledgeRead, user) => {
        const isSendCompletionSubscription =
          pledge?.products?.[0]?.parameters?.sendCompletionSubscription;
        if (!user?.sessionConsultant) {
          return true;
        }
        return !isSendCompletionSubscription;
      },
    },
    {
      name: 'documentVerification',
      template: 'documentVerification',
      title: 'Vérification des documents',
      // Cf. commentaire sur leadCompletionSubscription : pas de callbackBasedOn, isConsultant:true suffit.
      isConsultant: true,
      type: 'owners',
      category: 'Signature',
      productType: [],
    },
    {
      name: 'documentCompliance',
      template: 'documentCompliance',
      title: 'Conformité des documents',
      // Cf. commentaire sur leadCompletionSubscription : pas de callbackBasedOn, isConsultant:true suffit.
      isConsultant: true,
      type: 'owners',
      category: 'Signature',
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',
        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'sendDocument',

      template: 'sendDocument',

      title: 'Envoyer/Télécharger les documents',
      subTitle: 'Choisir les options des documents',
      isConsultant: true,
      type: 'owners',
      category: 'Signature',
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',
        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
    {
      name: 'finalPage',

      template: 'finalPage',
      title: '',
      category: 'Signature',
      productType: [
        'ASSURANCE_VIE',
        'CONTRAT_CAPI',
        'COMPTE_TITRE',
        'PEA',
        'PEI',
        'PEE',
        'PERCO',
        'PER',
        'SCPI',
        'GIRARDIN',
        'CROWDFUNDING',
        'FCPI',
        'FPCI',
        'BOND',
        'GFV',
        'GFI',
        'CONTINGENCY',
        'INSURANCE',
        'GFF',
        'TITRES_PARTICIPATIFS',
        'SOCIAL_SHARE',
        'OBLIGATIONS',
        'DIVERSIFICATION_INVESTMENT',
        'FCPR',
        'FPS',
        'PRIVATE_EQUITY',
        'FIP',
        'FIP_DOMTOM',
        'FIP_CORSE',
        'LMNP',
        'UNFURNISHED',
        'CAT',
        'BORROWER_INSURANCE',
        'PRESTATION',
      ],
    },
  ];
}
